import { queryParamsMapper } from '../mappers/query-params.mapper';
import { CourseDetail } from '../models/course-detail';
import { CourseStatus } from '../models/course-status';
import { LicenseStatus } from '../models/license-status';
import { Package } from '../models/package';
import { QueryParams } from '../models/query-params';
import { UserAccountStatus } from '../models/user-account-status';
import { Visibility, VISIBILITY_VALUE } from '../models/visibility';

export const DEFAULT_TABLE_QUERY_PARAMS = {
  searchString: '',
  packages: [],
  visibility: {
    name: VISIBILITY_VALUE.UNHIDDEN,
    value: 1,
  },
  userAccountStatus: null,
  courses: [],
  courseStatuses: [],
  attendanceStatuses: [],
  licenseStatuses: [],
  expirationStatuses: [],
  expiredOnly: null,
};

export class TableQueryParams extends QueryParams {
  constructor(data) {
    super(data);

    /** @type {CourseDetail[]} */
    this.courses = data.courses;

    /** @type {LicenseStatus[]} */
    this.licenseStatuses = data.licenseStatuses;

    /** @type {LicenseStatus[]} */
    this.attendanceStatuses = data.attendanceStatuses;

    /** @type {Visibility} */
    this.visibility = data.visibility;

    /** @type {UserAccountStatus} */
    this.userAccountStatus = data.userAccountStatus;

    /** @type {string} */
    this.searchString = data.searchString;

    /** @type {Package[]} */
    this.packages = data.packages;

    /** @type {CourseStatus[]} */
    this.courseStatuses = data.courseStatuses;

    /** @type {object[]} */
    this.expirationStatuses = data.expirationStatuses;

    /** @type {boolean | null} */
    this.expiredOnly = data.expiredOnly;
  }
}

/**
 * Prepare table query params.
 * @param {object} params Params.
 * @param {TableQueryParams} params.options Options.
 * @param {object | null} [params.sortField] Sort field.
 * @returns {object}
 */
export function prepareTableQueryParams({ options, sortField = null }) {
  const { expiredOnly: defaultExpiredOnly, expirationStatuses } = options;
  let expiredOnly = defaultExpiredOnly;
  if (expirationStatuses?.length === 1) {
    expiredOnly = expirationStatuses[0].value;
  } else if (!expirationStatuses || expirationStatuses.length !== 1) {
    expiredOnly = null;
  }

  return {
    ...queryParamsMapper.toDto(options, sortField),
    status_ids: options.licenseStatuses?.concat(options.attendanceStatuses).map(status => status.id),
    course_ids: options.courses?.map(course => course.id),
    term: options.searchString,
    visibility: options.visibility?.value,
    activation: options.userAccountStatus?.value,
    package_ids: options.packages?.map(p => p.id),
    course_statuses: options.courseStatuses?.map(status => status.value),
    expired_only: expiredOnly,
  };
}
